// extracted by mini-css-extract-plugin
module.exports = {"AvatarPicker":"AvatarPicker_AvatarPicker__2wcE2","Current":"AvatarPicker_Current__OxQaB"};